import { load_script } from '@phi/util/dom';
import { Gtag } from './gtag';
import { Result, map } from '@vaaas/fpts/result';
import { Option } from '@vaaas/fpts/option';

let gtag: Option<Gtag> = undefined;

export function initialise(tag: string): Promise<Result<Gtag>> {
    if (gtag)
        return Promise.resolve(gtag);
    else return load_script(`https://www.googletagmanager.com/gtag/js?id=${tag}`).then(map(x => {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        gtag = function gtag() {
            /* eslint-disable */
            // @ts-ignore
            dataLayer.push(arguments);
        };
        gtag('js', new Date());
        gtag('config', tag);
        return gtag;
    }));
}
